import {SoftDeleteEntity} from "./soft-delete-entity";
import {Card} from "./card";
import {TrustPayTransaction} from "./trustPayTransaction";
import {UploadLink} from "./upload-link";
import {WebIdTransaction} from "./web-id-transaction";
import {LoadRiskFlags} from "./loadRiskFlags";

export class BankTransferLoad extends SoftDeleteEntity {
  statementDate: Date;
  currencyCode: number;
  amount: number;
  amountToLoad: number;
  loadDate: Date;
  loadFee: number;
  description: string;
  card: Card | null;
  riskLevel: number;
  riskLevelAutomaticComment: string;
  isApprovedAutomatically: boolean;

  isApprovedManually: boolean;
  isDeclinedManually: boolean;
  needsManualApproval: boolean;
  createDate: Date;
  updateDate: Date | null;
  exportedDate: Date | null;
  isExported: boolean;
  isDocsRequested: boolean;
  isConfirmed: boolean;
  confirmedDate: Date;
  trustPayTransactionId: number;
  trustPayTransaction: TrustPayTransaction;
  uploadLinkId: number;
  uploadLink: UploadLink | null;
  needsDocs: boolean;
  isDocsApproved: boolean;
  webIdTransactionId: number;
  webIdTransaction: WebIdTransaction;
  loadType: number;
  isMarkedForRefund: boolean;
  markedForRefundDate: Date;
  isRefunded: boolean;
  refundedDate: Date;

  amountAlreadyLoaded: number | null;
  delayNextLoadUntil: Date | null;
  executionNotBefore: Date | null;


  approvedManuallyByUserName: string | null;
  exportedByUserName: string | null;
  declinedManuallyByUserName: string | null;

  // search 4-EYES BTL in backend
  // some loads will need to be approved by 2 users or by a super admin
  isPreApprovedManually: boolean;
  preApprovedManuallyByUserName: string | null;

  public isInstantLoad: boolean;
  public instantLoadDelayedUntil: Date | null;

  public hadError: boolean;
  public lastErrorDescription: string | null;
  public needsPreApproval = false;
  public isAddressConfirmationRequested = false;
  public isThirdPartyLoad = false;

  public delayedIndefinitely: boolean;

  riskFlags: LoadRiskFlags;
  sourceRiskType: BankTransferLoadSourceRiskType;

}

export enum BankTransferLoadSourceRiskType
{
  normal = 0,
  elevated = 1,
  high = 2,
  veryHigh = 3,
}

export class AmountAndCurrencyContainer {
  currencyCode: number;
  amount: number;
}

export class LoadTimeline {
  // make graph data

  days: LoadTimelineDay[] = [];

}

export class LoadTimelineDay {
  day: string;
  loadAmount: number;
  loadCount: number;
  pendingAmount: number;
  allowedAmount: number;
  allowedAmount1: number;
  allowedAmount2: number;
  allowedAmount3: number;
  blockedAmount1: number;
  blockedAmount2: number;
  blockedAmount3: number;
  incomingAmount: number;

}
